import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function recipesReducer(state = initialState.recipes, action) {
	switch(action.type) {
		case types.LOAD_RECIPES_SUCCESS:
			//debugger;
			return action.recipes;

		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/reducers/recipesReducer.js
 **/